// extracted by mini-css-extract-plugin
export var alertIcon = "_st-0";